import CrudCustom from '../../../libs/custom/CrudCustom';

let TarifService = new CrudCustom('/tarifs');
export default TarifService;
